import { getProducts, createProduct, updateProduct, deleteProduct, toggleProductStatus } from '@lib/firestore'
import { useState, useEffect, useCallback } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { useImageKit } from '@context/ImageKitContext'
import { db } from '@lib/firebase'

export const useAdminProducts = () => {
  const [products, setProducts] = useState([])
  const { deleteImage } = useImageKit()

  const fetchProducts = useCallback(async () => {
    const fetchedProducts = await getProducts({ includeInactive: true })
    setProducts(fetchedProducts)
  }, [])

  useEffect(() => {
    fetchProducts()
  }, [fetchProducts])

  const getNextAvailableId = useCallback(async () => {
    const productsRef = collection(db, 'products')
    const allProducts = await getDocs(productsRef)
    const usedIds = allProducts.docs
      .map(doc => Number.parseInt(doc.data().id))
      .sort((a, b) => a - b)
  
    let nextId = usedIds.length > 0 ? usedIds[usedIds.length - 1] + 1 : 1
  
    for (let i = 1; i <= usedIds.length; i++) {
      if (usedIds[i - 1] !== i) {
        nextId = i
        break
      }
    }
  
    return nextId.toString()
  }, [])
  
  const handleCreateProduct = async newProduct => {
    try {
      const id = await getNextAvailableId()
      await createProduct(id, { ...newProduct, id })
      fetchProducts()
    } catch (err) {
      console.error(err)
    }
  }

  const handleUpdateProduct = async (id, updatedProduct) => {
    try {
      if (id !== updatedProduct.id) {
        await deleteProduct(id)
        await createProduct(updatedProduct.id, updatedProduct)
      } else {
        await updateProduct(id, updatedProduct)
      }
      fetchProducts()
    } catch (err) {
      console.error(err)
    }
  }

  const handleDeleteProduct = async (id, imageFileId) => {
    try {
      await deleteProduct(id)
      if (imageFileId) {
        await deleteImage(imageFileId)
      }
      fetchProducts()
    } catch (err) {
      console.error(err)
    }
  }

  const handleToggleStatus = async (id, currentStatus) => {
    try {
      await toggleProductStatus(id, currentStatus)
      await fetchProducts()
    } catch (err) {
      console.error(err)
    }
  }

  return { products, handleCreateProduct, handleUpdateProduct, handleDeleteProduct, handleToggleStatus, getNextAvailableId }
}
